import Vue from 'vue'
import Router from 'vue-router'

// templates
// import TemplateLetter from '@/components/templates/Letter'

// layouts
import Default from '@/components/layouts/Default'
import Portfolio from '@/components/layouts/Portfolio'

// views
import Home from '@/components/Home'

import AboutUs from '@/components/AboutUs'
import UnmatchedQuality from '@/components/projects/UnmatchedQuality'

import HowItWorks from '@/components/projects/HowItWorks'
import FundraisingToolkit from '@/components/projects/FundraisingToolkit'

import Products from '@/components/Products'
import Bricks from '@/components/products/Bricks'
import Tiles from '@/components/products/Tiles'
import Symbols from '@/components/products/Symbols'
import Fonts from '@/components/products/Fonts'
import ProjectWebsite from '@/components/projects/ProjectWebsite'

import ProvenBenefits from '@/components/projects/ProvenBenefits'
import RoadmapToSuccess from '@/components/projects/RoadmapToSuccess'
import ProductGuide from '@/components/projects/ProductGuide'
import PricingGuide from '@/components/projects/PricingGuide'

import OurWork from '@/components/OurWork'
import CommunityProjects from '@/components/our-work/CommunityProjects'
import K12 from '@/components/our-work/k-12'
import Parks from '@/components/our-work/Parks'
import Churches from '@/components/our-work/Churches'
import Military from '@/components/our-work/Military'
import Clients from '@/components/our-work/Clients'

import Showroom from '@/components/virtual/Showroom'

import Faq from '@/components/Faq'
import Contact from '@/components/Contact'

// import Covid19 from '@/components/Covid19'
// import IntroductoryOffer from '@/components/IntroductoryOffer'
import NotFound from '@/components/NotFound'

Vue.use(Router)

/* global FRS_CAMPAIGN */
var prefix = ['/', FRS_CAMPAIGN, '/'].join('');

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/about-us',
            name: 'About Us',
            component: AboutUs
        },
        {
            path: '/products',
            name: 'Products',
            component: Products,
            meta: { isProject: true }
        },
        {
            path: '/proven-benefits',
            name: 'Proven Benefits',
            component: ProvenBenefits,
            meta: { isProject: true }
        },
        {
            path: '/unmatched-quality',
            name: 'Unmatched Quality',
            component: UnmatchedQuality,
            meta: { isProject: true }
        },
        {
            path: '/fundraising-toolkit',
            name: 'Fundraising Toolkit',
            component: FundraisingToolkit,
            meta: { isProject: true }
        },
        {
            path: '/roadmap-to-success',
            name: 'Roadmap to Success',
            component: RoadmapToSuccess,
            meta: { isProject: true }
        },
        {
            path: '/project-website',
            name: 'Project Website',
            component: ProjectWebsite,
            meta: { isProject: true }
        },
        {
            path: '/product-guide',
            name: 'Product Guide',
            component: ProductGuide,
            meta: { isProject: true }
        },
        {
            path: '/pricing-guide',
            name: 'Pricing Guide',
            component: PricingGuide,
            meta: { isProject: true }
        },
        {
            path: '/how-it-works',
            name: 'How It Works',
            component: HowItWorks,
            meta: { isProject: true }
        },
        {
            path: '/bricks',
            name: 'Bricks',
            component: Bricks
        },
        {
            path: '/tiles',
            name: 'Tiles',
            component: Tiles
        },
        {
            path: '/symbols',
            name: 'Symbols',
            component: Symbols
        },
        {
            path: '/fonts',
            name: 'Fonts',
            component: Fonts
        },
        {
            path: '/portfolio',
            alias: '/our-work',
            name: 'OurWork',
            component: OurWork,
            meta: { layout: Portfolio }
        },
        {
            path: '/community-projects',
            name: 'communityProjects',
            component: CommunityProjects,
            meta: { layout: Portfolio }
        },
        {
            path: '/k12-schools',
            name: 'k12',
            component: K12,
            meta: { layout: Portfolio }
        },
        {
            path: '/parks',
            name: 'parks',
            component: Parks,
            meta: { layout: Portfolio }
        },
        {
            path: '/churches',
            name: 'churches',
            component: Churches,
            meta: { layout: Portfolio }
        },
        {
            path: '/military',
            name: 'military',
            component: Military,
            meta: { layout: Portfolio }
        },
        {
            path: '/client-list',
            name: 'clients',
            component: Clients,
            meta: { layout: Portfolio }
        },

        {
            path: '/virtual/:id',
            name: 'Showroom',
            component: Showroom,
            meta: { layout: Default }
        },
        {
            path: '/faq',
            name: 'FAQ',
            component: Faq
        },
        {
            path: '/contact',
            name: 'Contact',
            component: Contact
        },
        {
            path: '/open-contact-form',
            name: 'OpenContactForm',
            beforeEnter () {
                window.open('https://frltdinforequest.paperform.co/', '_blank');
            }
        },
        {
            path: '/open-example-project-website',
            name: 'OpenExampleProjectWebsite',
            beforeEnter () {
                window.open('https://steelheads-legacy-bricks.paperform.co/', '_blank');
            }
        },
        {
            path: '/open-info-request-website',
            name: 'OpenInfoRequestWebsite',
            beforeEnter () {
                window.open('https://frltdinforequest.paperform.co/', '_blank');
            }
        },
        {
            path: '/open-callback-website',
            name: 'OpenCallbackWebsite',
            beforeEnter () {
                window.open('https://frltdcallback.paperform.co/', '_blank');
            }
        },
        /* {
            path: '/COVID19',
            name: 'Covid19',
            component: Covid19,
            meta: { letter: TemplateLetter }
        }, */
        /* {
            path: '/intro-offer',
            name: 'IntroductoryOffer',
            component: IntroductoryOffer
        }, */
        {
            path: '*',
            name: 'NotFound',
            component: NotFound
        }
    ],
    base: prefix
    // mode: 'history',
    // scrollBehavior: () => { return { x: 0, y: 0 } }
})



// WEBPACK FOOTER //
// ./src/router/index.js